import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { sanityClient } from "../lib/sanityClient";

function CarServicePage() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const query = `*[_type == "carService"]{
          _id, title, description, priceRange, 
          mechanics[]->{_id, name, yearsOfExperience},
          primaryImage, additionalImages
        }`;
        const fetchedServices = await sanityClient.fetch(query);
        setServices(fetchedServices);
      } catch (error) {
        console.error("Error fetching car services:", error);
      }
      setLoading(false);
    };

    fetchServices();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Car Service & Repair |237Mechanic</title>
        <meta
          name="description"
          content="Get professional car service and repair at ProPrimeMart. From routine maintenance to major repairs, we connect you with skilled mechanics."
        />
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">
        Car Service & Repair
      </h1>
      <p className="text-lg text-gray-600 text-center mb-8">
        Get professional car service and repair with our trusted mechanics. 
        We offer routine maintenance, oil changes, tire replacements, and 
        major repairs to keep your vehicle running smoothly.
      </p>

      {loading ? (
        <p className="text-center text-gray-500">Loading services...</p>
      ) : services.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div key={service._id} className="border rounded-lg p-4 shadow-lg">
              {service.primaryImage && (
                <img
                  src={service.primaryImage}
                  alt={service.title}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
              )}
              <h2 className="text-xl font-semibold">{service.title}</h2>
              <p className="text-gray-600 mt-2">{service.description}</p>
              <p className="text-blue-600 font-medium mt-2">
                Price Range: {service.priceRange}
              </p>
              <h3 className="font-semibold mt-4">Mechanics:</h3>
              <ul className="list-disc list-inside text-gray-700">
                {service.mechanics?.map((mechanic) => (
                  <li key={mechanic._id}>
                    {mechanic.name} ({mechanic.yearsOfExperience} years experience)
                  </li>
                ))}
              </ul>
              {service.additionalImages?.length > 0 && (
                <div className="mt-4">
                  <h3 className="font-semibold">More Images</h3>
                  <div className="flex space-x-2 overflow-auto">
                    {service.additionalImages.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`${service.title} ${index + 1}`}
                        className="w-20 h-20 object-cover rounded-md"
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center text-gray-500">
          No car services available at the moment.
        </p>
      )}
    </div>
  );
}

export default CarServicePage;
